import axios from "axios";
import { useUserStore } from "./stores/user";

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

const token = document.head.querySelector('meta[name="csrf-token"]');
const BASE_URL = import.meta.env.VITE_BASE_URL ?? "http://localhost:8080";

const instance = axios.create({
  withCredentials: true,
  baseURL: BASE_URL,
  headers: {
    common: {
      "X-Requested-With": "XMLHttpRequest",
      "X-CSRF-TOKEN": token != null ? token.content : undefined,
      "x-api-key": import.meta.env.VITE_API_KEY || "secret",
    },
  },
});

instance.interceptors.response.use(
  (reponse) => reponse,
  (error) => {
    const userStore = useUserStore();
    const errorStatus = error.response?.status;
    if (
      errorStatus === 401 &&
      !error.request.responseURL.includes("/api/users/logout")
    ) {
      if (userStore.isLoggedIn)
        userStore.logout();
    } else if (
      errorStatus === 403 ||
      errorStatus === 429 ||
      errorStatus === 500
    ) {
      // eslint-disable-next-line no-param-reassign
      error.response.data.message = `components.server.${errorStatus}`;
    } else if (error.code === "ERR_NETWORK") {
      error.response = {
        data: {
          message: "components.server.503",
        },
      };
    }
    return Promise.reject(error);
  }
);

export default instance;
